var _defs, _ellipse, _path, _path2, _path3, _rect, _path4, _rect2, _polygon, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _circle2, _circle3, _circle4, _circle5, _path16, _path17, _path18, _path19, _path20, _circle6, _circle7, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _g, _path57, _path58, _rect39, _path59, _path60, _g2, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _g3, _path68, _g4, _path69, _g5, _path70, _polygon2, _g6, _path71, _g7, _path72, _path73, _path74, _g8, _g9, _path75, _g10, _path76, _g11, _circle8, _g12, _path77, _path78, _g13, _g14, _circle9, _circle10, _circle11, _rect40, _rect41, _rect42, _rect43, _rect44, _ellipse2, _g15, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCity2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    width: 1142.71,
    height: 866.78,
    viewBox: "0 0 1142.71 866.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "7231b667-12f4-4b5a-a8d7-5fbb399f1f5b-347",
    x1: 919.5,
    y1: 866.87,
    x2: 919.5,
    y2: 345.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e499654a-3440-43b2-9cd0-3bdc531f1cd6-348",
    x1: 212.02,
    y1: 596.16,
    x2: 490.73,
    y2: 596.16,
    xlinkHref: "#7231b667-12f4-4b5a-a8d7-5fbb399f1f5b-347"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "57b4d689-d23d-4167-9afb-3be6c96fe0f2-349",
    x1: 325.27,
    y1: 618.36,
    x2: 326.52,
    y2: 618.36,
    xlinkHref: "#7231b667-12f4-4b5a-a8d7-5fbb399f1f5b-347"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eac37dd2-c948-4d6f-8054-18dfe5a953f0-350",
    x1: 326.25,
    y1: 619.33,
    x2: 327.5,
    y2: 619.33,
    xlinkHref: "#7231b667-12f4-4b5a-a8d7-5fbb399f1f5b-347"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9e04d387-eaa7-45ec-87d4-96689ba1bc0d-351",
    x1: 326.25,
    y1: 618.36,
    x2: 327.5,
    y2: 618.36,
    xlinkHref: "#7231b667-12f4-4b5a-a8d7-5fbb399f1f5b-347"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "missed chances") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 566.3,
    cy: 835.34,
    rx: 434.84,
    ry: 31.44,
    fill: "#479e35",
    opacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1158,707.62A86.27,86.27,0,0,1,1140.76,727c-1.84,1.52-3.75,3-5.69,4.38-24.84,17.84-58.1,25.68-90.41,30.76C981.93,772,917.89,773.92,854.12,775.8,800.43,777.4,746.71,779,693,780.06c-76.77,1.54-153.55,2-230.2,0q-62.85-1.65-125.6-5.82c-77.62-5.31-157.24-14.69-224.81-47.45a231.88,231.88,0,0,1-35.31-20.9c-18.35-13.37-33.46-29.55-41.54-48.71-13-30.8-6.13-65.41,8.72-95.61,9-18.26,20.69-35.36,32.82-52.31,7.18-10.06,14.52-20.06,21.5-30.21.73-1,1.44-2.07,2.14-3.11,1.35-2,2.69-4,4-6,5.48-8.43,10.67-17.13,15.43-26A294.25,294.25,0,0,0,133,416.72a237.37,237.37,0,0,0,9-26c1.66-5.95,3.06-11.92,4.14-17.89,5.91-32.51,2.79-65-14.71-94.41-.17-.29-.35-.6-.53-.89l-.22-.35c-4.94-8.11-10.9-15.75-16.76-23.42-7-9.2-13.89-18.46-18.74-28.59-12.76-26.77-10-56.87-5.36-85.46,6.19-38,17.71-79,53.38-102.69,37.05-24.66,89.65-23.41,135.64-14.59C350.3,36.1,416.29,64.77,482.92,90.64s136.39,49.53,209.65,52.06c64.69,2.25,140.14-14.55,183.07-58.25,41.7-42.43,120.09-45.66,176.61-20,53.92,24.45,88.79,76.21,86.17,127.89-3.82,75.27-76.36,133-119.64,198.86-1.94,2.94-3.83,5.95-5.63,9-17,28.73-27.47,61.72-14.93,91.63,16.82,40.07,66.76,59.62,108.88,84.79C1127.44,588.77,1146,602.24,1158,620c.45.64.86,1.27,1.27,1.9C1176.2,648.1,1174.92,681.56,1158,707.62Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.71,469.92c5.48-8.43,10.67-17.13,15.43-26A294.25,294.25,0,0,0,133,416.72a237.37,237.37,0,0,0,9-26c1.66-5.95,3.06-11.92,4.14-17.89,5.91-32.51,2.79-65-14.71-94.41-.17-.29-.35-.6-.53-.89l-17-23.77H240.05v83.76h35.09V588.77h45.28v-81.5h54.33v81.5H420V449.54h2.26V377.1h43v72.44h99.61V558.2h55.47v-34h34v34H709.8V236.74h72.44V185.8h12.45v50.94h20.37V337.48h36.23V253.72h30.56v-86h63.38v86H975.8v83.76h37.35v62.71c-17,28.73-27.47,61.72-14.93,91.63,16.82,40.07,66.76,59.62,108.88,84.79C1127.44,588.77,1146,602.24,1158,620v87.65A86.27,86.27,0,0,1,1140.76,727c-1.84,1.52-3.75,3-5.69,4.38-24.84,17.84-58.1,25.68-90.41,30.76C981.93,772,917.89,773.92,854.12,775.8,800.43,777.4,746.71,779,693,780.06H462.78q-62.85-1.65-125.6-5.82c-77.62-5.31-157.24-14.69-224.81-47.45a231.88,231.88,0,0,1-35.31-20.9V509.26c7.18-10.06,14.52-20.06,21.5-30.21Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.1,372.79v17.89H142C143.62,384.73,145,378.76,146.1,372.79Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#fff",
    opacity: 0.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 204.96,
    y: 363.52,
    width: 47.54,
    height: 27.17,
    transform: "translate(428.82 737.59) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.1,416.72v27.16h-26A294.25,294.25,0,0,0,133,416.72Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#fff",
    opacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 204.96,
    y: 416.72,
    width: 47.54,
    height: 27.17,
    transform: "translate(428.82 843.99) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "76.07 453.3 117.46 453.3 117.46 480.47 69.92 480.47 69.92 462.44 76.07 453.3",
    fill: "#fff",
    opacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 204.96,
    y: 469.92,
    width: 47.54,
    height: 27.17,
    transform: "translate(428.82 950.39) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 69.92,
    y: 506.51,
    width: 47.54,
    height: 27.17,
    fill: "#fff",
    opacity: 0.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 204.96,
    y: 523.12,
    width: 47.54,
    height: 27.17,
    transform: "translate(428.82 1056.79) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 69.92,
    y: 559.71,
    width: 47.54,
    height: 27.17,
    fill: "#fff",
    opacity: 0.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 204.96,
    y: 576.32,
    width: 47.54,
    height: 27.17,
    transform: "translate(428.82 1163.19) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 69.92,
    y: 612.91,
    width: 47.54,
    height: 27.17,
    fill: "#fff",
    opacity: 0.4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 204.96,
    y: 629.52,
    width: 47.54,
    height: 27.17,
    transform: "translate(428.82 1269.59) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 69.92,
    y: 666.11,
    width: 47.54,
    height: 27.17,
    fill: "#fff",
    opacity: 0.4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 204.96,
    y: 682.72,
    width: 47.54,
    height: 27.17,
    transform: "translate(428.82 1375.99) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 263.48,
    y: 599.32,
    width: 110.93,
    height: 13.58,
    fill: "#fff",
    opacity: 0.4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 263.48,
    y: 619.7,
    width: 110.93,
    height: 13.58,
    fill: "#fff",
    opacity: 0.4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 263.48,
    y: 640.07,
    width: 110.93,
    height: 13.58,
    fill: "#fff",
    opacity: 0.4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 553.25,
    y: 606.12,
    width: 110.93,
    height: 13.58,
    fill: "#fff",
    opacity: 0.4
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 553.25,
    y: 626.49,
    width: 110.93,
    height: 13.58,
    fill: "#fff",
    opacity: 0.4
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 553.25,
    y: 646.86,
    width: 110.93,
    height: 13.58,
    fill: "#fff",
    opacity: 0.4
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 263.48,
    y: 660.45,
    width: 110.93,
    height: 13.58,
    fill: "#fff",
    opacity: 0.4
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 263.48,
    y: 680.82,
    width: 110.93,
    height: 13.58,
    fill: "#fff",
    opacity: 0.4
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 263.48,
    y: 701.2,
    width: 110.93,
    height: 13.58,
    fill: "#fff",
    opacity: 0.4
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 415.15,
    y: 458.97,
    width: 30.56,
    height: 39.62,
    fill: "#fff",
    opacity: 0.4
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 510.58,
    y: 475.58,
    width: 30.56,
    height: 39.62,
    transform: "translate(1023.08 974.16) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 415.15,
    y: 522.35,
    width: 30.56,
    height: 39.62,
    fill: "#fff",
    opacity: 0.4
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 510.58,
    y: 538.97,
    width: 30.56,
    height: 39.62,
    transform: "translate(1023.08 1100.94) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 415.15,
    y: 585.74,
    width: 30.56,
    height: 39.62,
    fill: "#fff",
    opacity: 0.4
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 510.58,
    y: 602.35,
    width: 30.56,
    height: 39.62,
    transform: "translate(1023.08 1227.71) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 415.15,
    y: 649.13,
    width: 30.56,
    height: 39.62,
    fill: "#fff",
    opacity: 0.4
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 510.58,
    y: 665.74,
    width: 30.56,
    height: 39.62,
    transform: "translate(1023.08 1354.49) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 681.15,
    y: 246.17,
    width: 40.75,
    height: 52.07,
    fill: "#fff",
    opacity: 0.4
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 681.15,
    y: 320.87,
    width: 40.75,
    height: 52.07,
    fill: "#fff",
    opacity: 0.4
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 681.15,
    y: 395.58,
    width: 40.75,
    height: 52.07,
    fill: "#fff",
    opacity: 0.4
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 681.15,
    y: 470.29,
    width: 40.75,
    height: 52.07,
    fill: "#fff",
    opacity: 0.4
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 681.15,
    y: 544.99,
    width: 40.75,
    height: 52.07,
    fill: "#fff",
    opacity: 0.4
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 681.15,
    y: 619.7,
    width: 40.75,
    height: 52.07,
    fill: "#fff",
    opacity: 0.4
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 809.63,
    y: 352.57,
    width: 151.68,
    height: 44.14,
    fill: "#fff",
    opacity: 0.4
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 810.19,
    y: 447.65,
    width: 151.68,
    height: 44.14,
    fill: "#fff",
    opacity: 0.4
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 810.76,
    y: 542.73,
    width: 151.68,
    height: 44.14,
    fill: "#fff",
    opacity: 0.4
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 811.32,
    y: 637.81,
    width: 151.68,
    height: 44.14,
    fill: "#fff",
    opacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.39,277.49v.89c-.17-.29-.35-.6-.53-.89Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#fff",
    opacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1158,620v16.34H1107.1v-59.7C1127.44,588.77,1146,602.24,1158,620Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#fff",
    opacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1158,665.74v41.88A86.27,86.27,0,0,1,1140.76,727c-1.84,1.52-3.75,3-5.69,4.38h-28V665.74Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#fff",
    opacity: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M376.66,221.67h-7.79a5.45,5.45,0,0,0,0-10.9H305.78a5.45,5.45,0,0,0,0,10.9h7.79a5.46,5.46,0,0,0,0,10.91h-10.9a5.45,5.45,0,1,0,0,10.9h63.08a5.45,5.45,0,0,0,0-10.9h10.91a5.46,5.46,0,0,0,0-10.91Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M655.11,358.63h-7.79a5.45,5.45,0,0,0,0-10.9H584.23a5.45,5.45,0,0,0,0,10.9H592a5.46,5.46,0,0,0,0,10.91h-10.9a5.45,5.45,0,1,0,0,10.9H644.2a5.45,5.45,0,0,0,0-10.9h10.91a5.46,5.46,0,0,0,0-10.91Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1129.38,179.79h-7.79a5.45,5.45,0,1,0,0-10.9H1058.5a5.45,5.45,0,0,0,0,10.9h7.79a5.45,5.45,0,0,0,0,10.9h-10.9a5.46,5.46,0,0,0,0,10.91h63.08a5.46,5.46,0,1,0,0-10.91h10.91a5.45,5.45,0,0,0,0-10.9Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.84,448.29l.06-.09-.24-.16-.49-.33a.34.34,0,0,1,.09.08,2,2,0,0,0-2.63.56l-.3.41h0l-14,20.1-2.45,3.53c-7.36-2.22-19.32,7.12-25.39,12.47l-1.06.95c-.48-1.08-.76-1.76-.76-1.76-.3,3.28-11.91,8.21-14.62,10a9.94,9.94,0,0,1-4,1.36c.38-12.51-9.28-25.67-9.28-25.67l-23.61-30.08a26.54,26.54,0,0,1,2.41-15.95c.19-.39.4-.78.62-1.17.33,0,.68,0,1,0h.13a33.05,33.05,0,0,0,5.75-.51A31.49,31.49,0,0,0,976,393c2.38-.61,4.4-2.82,4.06-5.36a4,4,0,0,0,0-1.46h0a5.38,5.38,0,0,0-.27-.89h0c-.67-1.71-2.11-3.09-3.15-4.65a14.33,14.33,0,0,1-2.25-7.65,30.22,30.22,0,0,1,1.1-7,12,12,0,0,0,.67-4.24l0-.29a6.11,6.11,0,0,0-.05-1.13,5.35,5.35,0,0,0-.19-.79h0a7.51,7.51,0,0,0-3.16-3.86c-3.74-2.44-8.53-2.48-12.73-4-6.1-2.23-11.61-7.74-18-6.41-3.48.72-6.15,3.39-9.16,5.27a22.15,22.15,0,0,1-11.05,3.36c-3.29.1-6.62-.54-9.86,0a10.29,10.29,0,0,0-1.71.46,25.43,25.43,0,0,0-8.56-1.35,14.41,14.41,0,0,0-8.08,2.23c-4.38,3.05-5.54,9-5.48,14.29a.53.53,0,0,0,0,.13c0,.35,0,.69,0,1,0,2.54.25,5.12.3,7.66a23.32,23.32,0,0,1-1,7c-2,6.28-7.79,11.08-8.95,17.59a14.91,14.91,0,0,0-.2,3.4c-.08,3.68,1.1,7.37,2.19,10.94,2.26,7.38,4,15.22,4.06,22.88A37.75,37.75,0,0,1,881.74,454a20.63,20.63,0,0,1-2,3.67c-.26.36-.53.72-.82,1.06l-.11.13c-.25.29-.52.56-.79.82l-.22.21a9.89,9.89,0,0,1-.81.64l-.27.2a8.55,8.55,0,0,1-1.18.67l2-.12a9.53,9.53,0,0,1-2,1.28l10.62-.62a2,2,0,0,1,.05.35,5.36,5.36,0,0,1-.15.78,6.34,6.34,0,0,1-.26.73,1,1,0,0,1,0,.1,6.11,6.11,0,0,1-.82,1.33l-.09.1a5.68,5.68,0,0,1-.53.57h0a5.26,5.26,0,0,1-.58.45l-.13.1a6.15,6.15,0,0,1-.66.37h0a5.6,5.6,0,0,1-.68.26l-.18.05a4.4,4.4,0,0,1-.74.14l1-.11c.67-.08,1.34-.17,2-.28l.2,0a5.35,5.35,0,0,1-3.2,1.59,29.3,29.3,0,0,0,6.73-1.33c1.38,9.29,4.45,37.6,2.76,42.83-1.81,5.57,2.81,46.41,2.81,46.41s.63,3.13,1.73,7.8c-2.84,6.71-6.08,14.13-7.71,17.11-3.26,6-1.66,36.46,9.6,50,0,0,4.66,6.57,3.43,9s.21,6.58.21,6.58l1.78,39.44a102,102,0,0,1-.83,12.05c-4.79,5.95-12.2,14.62-15.68,16-5.39,2.19-45.59,51-45.59,51s.32.59.95,1.55l-1.13,1.31-7.71,8.94-.61.71c-1.45-.27-11.08-2-18.74-2.58l-.75-.05v-.13a28.4,28.4,0,0,0-8.08.21l-.06,0v0a2.63,2.63,0,0,0-1.33.7c-2.61,3.19-4,53.4-4,53.4s2.78,25.08,11.42,26.52a5,5,0,0,0,1.4.27H812a3.89,3.89,0,0,0,.48,0c6.2-.45,9-4,10.29-6.45a10.47,10.47,0,0,0,.86-2.32s-1-4.48,1.71-10.65,7.74-16.94,7.74-16.94,9.19-9.67,7.55-14.36l.88-1.27c3.46-4.92,10.43-14.64,16.07-21.13l1.1-1.25a27.85,27.85,0,0,0,6.41,1.86s8.64-3.38,11.86-11c1.37-3.22,6.73-8.92,12.44-14.42-.12.94-.18,1.47-.18,1.47l-.2,48a33.72,33.72,0,0,0,5.91,3.25c0,.39,0,.79,0,1.2a154.83,154.83,0,0,1-1.23,20.47l-.18,1.06c-.71-.51-1.32-.68-1.72-.28-1.77,1.79-2.87,13.25-3,18.53,0,.1,0,.2,0,.3h0c-.12,2.18-.7,4.78-.7,7.1-.06,3.37,1,6.21,6.45,6.45,6.77.28,35.89.73,51.48,1a34.58,34.58,0,0,0,23-8.15c2.86-2.45,5.05-5.17,5.12-7.74.14-2-.93-3.87-3.91-5.51a1.17,1.17,0,0,1-.06.2c-.39-.21-.81-.42-1.27-.62l-15-2.35L928.4,829.65s-.15-7.88-3.21-6.57a8.51,8.51,0,0,0-2.59,1c-.15-.3-.31-.6-.46-.92a29.53,29.53,0,0,1-3.15-13.3c0-.42,0-.84.06-1.27a23,23,0,0,0,2.12-2.17s-.2-17.93,1.8-21.32,8.25-37.66,8.25-37.66.2-6.37,4.22-10.16,2.61-14.74,2.61-14.74,5.62-3,7.43-12.75,7.64-31.08,7.64-31.08,12.06-31.48,11.26-51.4,1.2-30.28,1.2-30.28l2.51-46.29,0-.72c1,.77,1.67,1.38,1.67,1.38s0-.18,0-.5l.58.5s1.28-21,.85-29.33c7-2.39,17.74-6.32,18.34-8.32.91-3,13-12.4,13-12.4a2.22,2.22,0,0,1-.73-.28c.38-.17.77-.38,1.19-.6,7.9-4.24,22.59-16.61,20.12-24.18l16.06-23.1A3.93,3.93,0,0,0,1038.84,448.29ZM908,425.83a9.22,9.22,0,0,0-1.17.09,88.8,88.8,0,0,0-3-12.17c-1.86-6.26-3.86-12.56-4.16-19.07,0-.28,0-.57,0-.85a22.92,22.92,0,0,1,.67-5.09c.38.71.81,1.41,1.25,2.07,2.57,3.88,5.57,7.57,7.15,11.94.72,2,1.14,4.17,2.24,6s3.13,3.38,5.27,3.05a4.14,4.14,0,0,0,2-.91A84.48,84.48,0,0,1,908,425.83Z",
    transform: "translate(-28.64 -16.61)",
    fill: "url(#7231b667-12f4-4b5a-a8d7-5fbb399f1f5b-347)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.17,505.51a10.56,10.56,0,0,1-3.79,1.44c-5,.14-9-13.25-9-13.25s1.41-1.43,3.65-3.43c6.63-5.89,20.55-16.78,27.07-10.69C1025.39,486.41,1008.69,500.9,1000.17,505.51Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#ecb4b6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M925,824.86l-18.25,19.7s-16.89.19-13.58-9.13a35.59,35.59,0,0,0,1.4-6.19,151.83,151.83,0,0,0,1.19-20c0-4.37-.07-7.43-.07-7.43s26.59-11.65,23.87.48A22.62,22.62,0,0,0,919,807a28.93,28.93,0,0,0,3,12.95A29.64,29.64,0,0,0,925,824.86Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#ecb4b6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M925,824.86l-18.25,19.7s-16.89.19-13.58-9.13a35.59,35.59,0,0,0,1.4-6.19c2.41,1.86,5.88,7.36,5.88,7.36s11.64,3.4,14.84-6.79c1.8-5.7,4.62-8.52,6.77-9.9A29.64,29.64,0,0,0,925,824.86Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M967.33,854.53a33.23,33.23,0,0,1-22.23,8c-15.05-.22-43.18-.66-49.71-.93-8.74-.38-5.84-7.84-5.56-13,0-.18,0-.35,0-.52.1-5.14,1.17-16.3,2.88-18s7.71,7.76,7.71,7.76,11.64,3.4,14.84-6.79S925,819.81,925,819.81c3-1.28,3.11,6.4,3.11,6.4l24.65,12.72,14.46,2.28c.47.21.89.43,1.29.64C975,845.47,972.12,850.39,967.33,854.53Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 893.14,
    cy: 817.27,
    r: 1.07,
    fill: "#fff",
    opacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 903.14,
    cy: 822.22,
    r: 1.07,
    fill: "#fff",
    opacity: 0.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 908.29,
    cy: 824.53,
    r: 1.07,
    fill: "#fff",
    opacity: 0.25
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 918.96,
    cy: 828.63,
    r: 1.07,
    fill: "#fff",
    opacity: 0.25
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 913.53,
    cy: 826.88,
    r: 1.07,
    fill: "#fff",
    opacity: 0.25
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M967.33,854.53a33.23,33.23,0,0,1-22.23,8c-15.05-.22-43.18-.66-49.71-.93-8.74-.38-5.84-7.84-5.56-13L944.69,852s22.47-3.41,23.81-10.1C975,845.47,972.12,850.39,967.33,854.53Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M967.33,854.31a33.22,33.22,0,0,1-22.23,7.94c-15.05-.22-43.18-.65-49.71-.93-8.74-.38-5.84-7.84-5.56-13l54.86,3.39s22.47-3.41,23.81-10.1C975,845.25,972.12,850.17,967.33,854.31Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#fff",
    opacity: 0.25
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M865.2,775.36a38,38,0,0,0-5.51,5.51c-5.44,6.33-12.17,15.8-15.51,20.59-1.29,1.86-2.08,3-2.08,3l-7.28-1.08s-7.86-12-7.76-12.32,6.21-13.2,6.21-13.2l2.37-2.77,7.46-8.72,3.37-3.94S871.8,770.6,865.2,775.36Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#ecb4b6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M844.18,801.46c-1.29,1.86-2.08,3-2.08,3l-7.28-1.08s-7.86-12-7.76-12.32,6.21-13.2,6.21-13.2l2.37-2.77.78.14h1.84c-6.5,6.79.49,21.74.49,21.74S841.77,797.27,844.18,801.46Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M836,816.69s-4.86,10.48-7.48,16.5-1.65,10.39-1.65,10.39a10,10,0,0,1-.83,2.25,11.45,11.45,0,0,1-9.94,6.29,2.46,2.46,0,0,1-.47,0C806.82,851.89,804,826.2,804,826.2s1.35-48.91,3.88-52a2.37,2.37,0,0,1,1.28-.68,27.14,27.14,0,0,1,7.79-.21c8,.57,18.3,2.54,18.3,2.54h1.84c-6.5,6.79.48,21.74.48,21.74s3.11.29,5.54,4.66S836,816.69,836,816.69Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 796.71,
    cy: 785.53,
    r: 1.07,
    fill: "#fff",
    opacity: 0.25
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 796.18,
    cy: 794,
    r: 1.07,
    fill: "#fff",
    opacity: 0.25
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M825.35,845.65c-1.2,2.37-4,5.84-9.94,6.29H815c-8.85-.23-11.67-25.92-11.67-25.92s1.36-48.91,3.88-52a2.41,2.41,0,0,1,1.28-.68,27.22,27.22,0,0,1,7.8-.21c-.15,8.78-.56,36.58,0,39.34S821.83,838.25,825.35,845.65Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M826,845.83a11.44,11.44,0,0,1-9.94,6.29,2.46,2.46,0,0,1-.47,0c-8.85-.23-11.66-25.92-11.66-25.92s1.36-48.91,3.88-52a2.41,2.41,0,0,1,1.28-.68,27.2,27.2,0,0,1,7.8-.21c-.15,8.78-.57,36.58,0,39.34S822.47,838.43,826,845.83Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#fff",
    opacity: 0.25
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M815,851.94c-8.85-.23-11.67-25.92-11.67-25.92s1.36-48.91,3.88-52a2.41,2.41,0,0,1,1.28-.68c1.86,2.76,3.49,8.87,2,22.32-2.76,25.48.57,27.08.57,27.08S815.15,844.34,815,851.94Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M814.88,851.94C806,851.71,803.21,826,803.21,826s1.36-48.91,3.88-52a2.41,2.41,0,0,1,1.28-.68c1.86,2.76,3.48,8.87,2,22.32-2.76,25.48.57,27.08.57,27.08S815.08,844.34,814.88,851.94Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.17,505.51a10.56,10.56,0,0,1-3.79,1.44c-5,.14-9-13.25-9-13.25s1.41-1.43,3.65-3.43C992.58,493.93,997.05,503.7,1000.17,505.51Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M968.42,500.69s4.08.29,6.7-1.46,13.83-6.55,14.12-9.75c0,0,6.7,16.3,10.48,16.88,0,0-11.64,9.18-12.52,12.09s-23.58,10-23.58,10Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#ff748e"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M968.42,500.69s4.08.29,6.7-1.46,13.83-6.55,14.12-9.75c0,0,6.7,16.3,10.48,16.88,0,0-11.64,9.18-12.52,12.09s-23.58,10-23.58,10Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M865.2,775.36a38,38,0,0,0-5.51,5.51c-8.77-3.68-14.44-11.18-16.59-14.48l3.37-3.94S871.8,770.6,865.2,775.36Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M906.74,692.76s-14.24,19-19.44,21.16-44,49.69-44,49.69S851.62,779,867,781.47c0,0,8.35-3.3,11.45-10.67S906,742.65,906,742.65Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#5e5a6b"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M906.74,692.76s-14.24,19-19.44,21.16-44,49.69-44,49.69S851.62,779,867,781.47c0,0,8.35-3.3,11.45-10.67S906,742.65,906,742.65Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M863.6,756.48a61.59,61.59,0,0,0,13,0C884.28,755.75,878.45,760.41,863.6,756.48Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M860.11,761.43s10.19,5.82,14.12,2.91S870.44,767.15,860.11,761.43Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M919.55,802.34A22.62,22.62,0,0,0,919,807c-7.87,7.14-17.34,4.94-23.26,2.33,0-4.37-.07-7.43-.07-7.43S922.27,790.21,919.55,802.34Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M966.72,549.12l-.29,5.37L964,599.59s-2,10.09-1.17,29.5S952,679.17,952,679.17s-5.63,20.78-7.38,30.29-7.18,12.42-7.18,12.42,1.36,10.68-2.52,14.36-4.07,9.9-4.07,9.9-6,33.39-8,36.69-1.75,20.77-1.75,20.77c-12.62,14.95-31.06,1.36-31.06,1.36l.19-46.78s5.25-43.09,9.13-49.11,3.88-22.52,3.88-22.52l-1.73-38.43s-1.38-4.08-.19-6.41S898,633,898,633c-10.87-13.2-12.42-42.9-9.27-48.73s12.59-29.11,12.59-29.11l13-7.58,23.47.7Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#5e5a6b"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M911.5,777.88s3.07,10.63,5.54,11.79S911.5,777.88,911.5,777.88Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M915.72,742.5s8,6.28,11.29,6.26S915.72,742.5,915.72,742.5Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M963.62,479.72v12.81l-8.46-3.64-8.43-3.64L928.39,467.2s-14.51-9.43-22.28-18c-4.44-4.9-6.68-9.53-2.76-12a24.51,24.51,0,0,0,5.07-4.45,83.53,83.53,0,0,0,10.13-14.94l.36-.65c3.78-6.94,6.27-12.86,6.27-12.86s10.64,3.41,17.49,8.24c.55.38,1.07.78,1.57,1.19,3.82,3.13,5.71,6.75,2.2,10.37a27.07,27.07,0,0,0-2.51,3h0a22.67,22.67,0,0,0-1.55,2.45c-.21.38-.41.76-.6,1.13a26.11,26.11,0,0,0-2.33,15.55Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#ecb4b6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M946.44,424.11a27.07,27.07,0,0,0-2.51,3h0a22.67,22.67,0,0,0-1.55,2.45c-.21.38-.41.76-.6,1.13a30.5,30.5,0,0,1-22.87-12.36q-.2-.25-.36-.51l.36-.65c3.78-6.94,6.27-12.86,6.27-12.86s10.64,3.41,17.49,8.24c.55.38,1.07.78,1.57,1.19C948.06,416.87,950,420.49,946.44,424.11Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M974.07,399a30.52,30.52,0,0,1-30.57,30.57h-.13c-.33,0-.67,0-1,0a30.57,30.57,0,1,1,31.51-33.92A31.15,31.15,0,0,1,974.07,399Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#ecb4b6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M947.51,474.58s15.4,8.69,11.45,1.36l-20.09-29.7h0l22.81,29.31s14.56,20,6.6,33.77c0,0-1.17,11.46.19,14.17s-.39,31.65-.39,31.65-5.43-5-8.34-4.08-23.49,2.72-23.49,2.72Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M966.72,549.12l-.29,5.37c-1.84-1.34-4.41-2.84-6.11-2.27-2.91,1-23.49,2.72-23.49,2.72l.95-6.68Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M948.09,474.58s15.4,8.69,11.45,1.36l-20.09-29.7h0l22.81,29.31s14.56,20,6.6,33.77c0,0-1.16,11.46.19,14.17s-.38,31.65-.38,31.65-5.44-5-8.35-4.08-23.49,2.72-23.49,2.72Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#464353"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M956.32,489.47c-.9,9.33-4.74,20.43-4.74,20.43s-2.71,27.57-6.21,35.73-1.94,19.41-3.88,40.18c-.7,7.47-3.11,12.61-6.36,16.08-5.34,5.7-13,6.89-19,6.54-.49,0-1-.06-1.43-.11-9.71-1-19-47.75-19-47.75s-4.46-39.79-2.72-45.23-1.74-36.49-2.91-43.29c-.74-4.3,1.49-11.34,3.21-15.91,1-2.65,1.84-4.47,1.84-4.47s3.3-10.48,8.73-15.91a8,8,0,0,1,5.76-2.42,14.3,14.3,0,0,1,7.19,2.25l.25.17s35.33,36.1,38.63,44.45C956.58,482.53,956.67,485.87,956.32,489.47Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M955.16,488.89c-.9,9.33-4.74,20.43-4.74,20.43s-2.72,27.57-6.21,35.72-2,19.41-3.88,40.18c-.7,7.48-3.11,12.62-6.36,16.09-5.35,5.7-13,6.89-19,6.54l-1.42-.11c-9.71-1-19-47.75-19-47.75s-4.46-39.8-2.71-45.23-1.75-36.49-2.91-43.29c-.74-4.3,1.48-11.34,3.21-15.92,1-2.64,1.83-4.46,1.83-4.46s3.3-10.48,8.74-15.92a8,8,0,0,1,5.75-2.41,14.35,14.35,0,0,1,7.2,2.25l.25.16s35.33,36.11,38.62,44.45C955.41,482,955.51,485.29,955.16,488.89Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M915.58,631s-8,7.13-10.78,6.84S915.58,631,915.58,631Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M917.71,637.84s-8.44,3.92-11,4.5S914.45,636.83,917.71,637.84Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M950.37,530.68s12.52.14,14.41,4.07S954.45,529.08,950.37,530.68Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M948.62,537.52s9.61,2,12.52,4.37S948.62,537.52,948.62,537.52Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M932.47,513.79s-1.16,39.45-5.46,44.55S932.47,513.79,932.47,513.79Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M921.69,625.31s-8,34.79,8.09,37,11.13-39.6,11.13-39.6Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M921.11,624.72s-8,34.8,8.08,37,11.14-39.6,11.14-39.6Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#ecb4b6"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M934.87,478.66c-.83-20.91-30.09-25.23-36.92-5.45-.05.13-.09.26-.14.4-4.46,13.39-2.52,47.3-2.52,47.3s.58,22.77,2.72,30.34,8.15,29.31,8.15,32.81,5.58,16.89,7.93,17.86,3.54,8.54,4.11,9.9,2.33,19,2.33,19,21.93-1.36,22.32-4.85S938,605.41,938,605.41s-3.87-7-4.36-12.62-3.6-8.15-3-12-1.75-5.83-1.75-8.35-1.74-9.32-1.74-9.32-3.69-2.91-3.11-6.4-5.24-10.48-3.69-13,1.94-8.73,1.94-8.73,1.94-28,3.3-35.53,9.32-19.79,9.32-19.79S934.89,479.28,934.87,478.66Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M934,601.31c-5.35,5.7-13,6.89-19,6.54-.69-2.65-1.71-5.9-3.2-6.52-2.35-1-7.93-14.36-7.93-17.85s-6-25.24-8.15-32.81S893,520.33,893,520.33,891,486.42,895.49,473c0-.14.08-.27.13-.41,6.83-19.78,36.09-15.45,36.92,5.46,0,.62,0,1,0,1s-8,12.23-9.31,19.8-3.31,35.52-3.31,35.52-.39,6.22-1.94,8.74,4.27,9.51,3.69,13,3.1,6.4,3.1,6.4,1.75,6.79,1.75,9.32,2.33,4.46,1.75,8.35,2.53,6.4,3,12A31.36,31.36,0,0,0,934,601.31Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M933.7,478.08c-.83-20.91-30.08-25.24-36.91-5.46,0,.14-.1.27-.14.41-4.46,13.39-2.52,47.3-2.52,47.3s.58,22.77,2.71,30.34S905,580,905,583.48s5.57,16.88,7.93,17.85,3.54,8.55,4.11,9.9,2.32,19,2.32,19,21.94-1.36,22.32-4.86-4.85-20.57-4.85-20.57-3.86-7-4.36-12.62-3.6-8.15-3-12-1.75-5.83-1.75-8.35-1.75-9.32-1.75-9.32-3.69-2.91-3.1-6.4-5.25-10.49-3.69-13,1.94-8.73,1.94-8.73,1.94-28,3.3-35.53,9.32-19.8,9.32-19.8S933.73,478.7,933.7,478.08Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M897.67,531.84c.58-.58,11.65-12.81,15.14-8.44S897.67,531.84,897.67,531.84Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M898.69,541.3c.43-.43,11.06-.87,13.68-6.84S898.69,541.3,898.69,541.3Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M886.58,434a2.94,2.94,0,0,1,.58,1.05,4.55,4.55,0,0,0-.58-4c-.52-.6-1.28-.95-1.75-1.58,0-.05-.06-.11-.1-.17a3,3,0,0,0,.1,3.08C885.3,433,886.06,433.36,886.58,434Z",
    transform: "translate(-28.64 -16.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.39,396.23c0-1.11.05-2.21,0-3.3-.21-4-.94-8-1.11-12-.23,4.86.85,10,1.11,14.91Z",
    transform: "translate(-28.64 -16.61)"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.41,497.19l.6.42a2.42,2.42,0,0,1-.62-3.35l27-39.16a2.4,2.4,0,0,1,3.34-.61l-.59-.42a3.86,3.86,0,0,1,1,5.37l-25.32,36.76A3.86,3.86,0,0,1,1004.41,497.19Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#464353"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.4,449.22h.78a0,0,0,0,1,0,0v52.36a0,0,0,0,1,0,0h-.78a1.74,1.74,0,0,1-1.74-1.74V451A1.74,1.74,0,0,1,1019.4,449.22Z",
    transform: "translate(420.9 -510.76) rotate(34.56)",
    fill: "#9f9eff"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 1029.53,
    y: 459.73,
    width: 0.49,
    height: 4.27,
    rx: 0.17,
    ry: 0.17,
    transform: "translate(415.14 -519.31) rotate(34.56)",
    fill: "#464353"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M977.91,395.26c-.43-2.09-2.14-3.62-3.32-5.4-2.94-4.43-2.48-10.29-1.11-15.43a11,11,0,0,0,.63-4.38,6.93,6.93,0,0,0-3.24-4.54c-3.61-2.37-8.24-2.4-12.29-3.9-5.89-2.18-11.22-7.55-17.36-6.25-3.36.71-5.94,3.31-8.84,5.14a21.31,21.31,0,0,1-10.68,3.27c-3.18.1-6.39-.52-9.52,0a9.6,9.6,0,0,0-1.65.45,24.78,24.78,0,0,0-8.27-1.32,13.9,13.9,0,0,0-7.8,2.18c-4.23,3-5.36,8.75-5.29,13.92s.94,10.5-.65,15.42c-2,6.13-7.52,10.8-8.64,17.14-.76,4.31.66,8.66,1.93,12.85,3.64,12,6.05,25.32,1.22,36.93-1.23,2.94-3.07,5.85-6,7.2l10.26-.61a5.58,5.58,0,0,1-4.68,6.36,23.82,23.82,0,0,0,7.53-1.73,8,8,0,0,0,4.75-5.74c.2-1.39-.1-2.84.29-4.18.67-2.31,3-3.58,4.95-5.06,5-3.9,7.38-10.47,7.57-16.82s-1.49-12.59-3.29-18.69-3.73-12.23-4-18.58a24.41,24.41,0,0,1,.64-6.91c.37.69.78,1.37,1.21,2,2.48,3.78,5.38,7.37,6.9,11.63a33.75,33.75,0,0,0,2.16,5.87c1.06,1.8,3,3.29,5.09,3s3.61-2.55,4.3-4.67,1-4.43,2.27-6.24c2.44-3.42,7.32-3.73,11.52-3.6,8.85.28,21.06,1.62,28-5.18,1.32-1.29,2-3.26,4-2.78,1.84.43,2.87,3.43,4.84,4.1C974.56,401.82,978.64,398.82,977.91,395.26Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M977.91,394.13c-.43-2.09-2.14-3.63-3.32-5.4-2.94-4.44-2.48-10.3-1.11-15.43a11,11,0,0,0,.63-4.38,6.93,6.93,0,0,0-3.24-4.54c-3.61-2.37-8.24-2.41-12.29-3.9-5.89-2.18-11.22-7.55-17.36-6.25-3.36.71-5.94,3.31-8.84,5.14a21.41,21.41,0,0,1-10.68,3.27c-3.18.1-6.39-.52-9.52,0a9.6,9.6,0,0,0-1.65.45,24.78,24.78,0,0,0-8.27-1.32,14,14,0,0,0-7.8,2.17c-4.23,3-5.36,8.76-5.29,13.93s.94,10.5-.65,15.42c-2,6.13-7.52,10.8-8.64,17.14-.76,4.31.66,8.66,1.93,12.85,3.64,12,6.05,25.32,1.22,36.92-1.23,2.95-3.07,5.86-6,7.21l10.26-.61a5.57,5.57,0,0,1-4.68,6.35,23.54,23.54,0,0,0,7.53-1.72,8,8,0,0,0,4.75-5.74c.2-1.39-.1-2.84.29-4.18.67-2.31,3-3.58,4.95-5.06,5-3.9,7.38-10.47,7.57-16.82s-1.49-12.6-3.29-18.69-3.73-12.23-4-18.58a24.41,24.41,0,0,1,.64-6.91c.37.69.78,1.37,1.21,2,2.48,3.78,5.38,7.37,6.9,11.63a33.35,33.35,0,0,0,2.16,5.86c1.06,1.8,3,3.3,5.09,3s3.61-2.54,4.3-4.66,1-4.43,2.27-6.24c2.44-3.42,7.32-3.73,11.52-3.6,8.85.28,21.06,1.62,28-5.18,1.32-1.29,2-3.26,4-2.78,1.84.43,2.87,3.43,4.84,4.1C974.56,400.69,978.64,397.69,977.91,394.13Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#464353"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M889.2,375.9q0,1,0,2c0,2.16.18,4.35.26,6.52C889.55,381.62,889.3,378.75,889.2,375.9Z",
    transform: "translate(-28.64 -16.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.7,443.91c.27-8-1.55-16.25-3.89-24a45.54,45.54,0,0,1-2-8.54c-.43,4,.86,8,2,11.94A82.49,82.49,0,0,1,885.7,443.91Z",
    transform: "translate(-28.64 -16.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.48,378.94a32.17,32.17,0,0,1,1-5.64,11,11,0,0,0,.63-4.38,4.81,4.81,0,0,0-.19-.77c-.12.59-.28,1.17-.44,1.75A26.65,26.65,0,0,0,972.48,378.94Z",
    transform: "translate(-28.64 -16.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.32,463.45l-6.2.36a10.3,10.3,0,0,1-4.06,3.64l9.68-.57A5.2,5.2,0,0,0,887.32,463.45Z",
    transform: "translate(-28.64 -16.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.64,393.25a5.37,5.37,0,0,1-6.31,2.95c-2-.67-3-3.67-4.84-4.1-2-.48-2.68,1.5-4,2.79-6.93,6.79-19.14,5.45-28,5.17-4.2-.13-9.08.18-11.52,3.6-1.3,1.81-1.59,4.13-2.27,6.25s-2.1,4.32-4.3,4.66-4-1.17-5.09-3a34,34,0,0,1-2.16-5.86c-1.52-4.26-4.42-7.86-6.9-11.64-.43-.64-.84-1.32-1.21-2a24.45,24.45,0,0,0-.64,6.92c0,.16,0,.33,0,.49a22.44,22.44,0,0,1,.6-4c.37.69.78,1.37,1.21,2,2.48,3.78,5.38,7.37,6.9,11.63a33.35,33.35,0,0,0,2.16,5.86c1.06,1.8,3,3.3,5.09,3s3.61-2.54,4.3-4.66,1-4.43,2.27-6.24c2.44-3.42,7.32-3.73,11.52-3.6,8.85.28,21.06,1.62,28-5.18,1.32-1.29,2-3.26,4-2.78,1.84.43,2.87,3.43,4.84,4.1,3.23,1.09,7.31-1.91,6.58-5.47A6.87,6.87,0,0,0,977.64,393.25Z",
    transform: "translate(-28.64 -16.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.16,453.09c-1.9,1.48-4.28,2.75-4.95,5.06-.39,1.35-.09,2.79-.29,4.18a8,8,0,0,1-4.75,5.75,15.08,15.08,0,0,1-2.95,1,5.59,5.59,0,0,1-4.58,4.11,23.54,23.54,0,0,0,7.53-1.72,8,8,0,0,0,4.75-5.74c.2-1.39-.1-2.84.29-4.18.67-2.31,3-3.58,4.95-5.06,5-3.9,7.38-10.47,7.57-16.82,0-.95,0-1.89,0-2.83C907.37,443,905,449.31,900.16,453.09Z",
    transform: "translate(-28.64 -16.61)"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M484.14,835.41l.23,0s-36.72-99.58-47-113.11c0,0-10.77-6.29-10.28-16.92L413.88,642s.2-.19.53-.55l.28-.31c.1-.11.21-.23.32-.37A29.79,29.79,0,0,0,419.4,634c.07-.16.15-.31.22-.47a25.46,25.46,0,0,0,1.23-3.42,3.74,3.74,0,0,0,2.82-.15s0-.34,0-.95l0,0s-.13-3.75-.14-9.61c0-1.64,0-3.42,0-5.31a47,47,0,0,0,1.05-4.62l-.54-.25c0-.08,0-.15.05-.23l-.45-.21c.36-13.9,1.56-31.66,5-43.76.12-.43.24-.85.37-1.27,4.08-13.21,4.17-29.34,5.22-43a42.22,42.22,0,0,1,2.12,5.28,8,8,0,0,1,1.78-1.47l4.1,32.41v38.18s-6.86,49.31,14.68,40.13,5.88-43,5.88-43,0-18.85,2.94-28.52c1.93-6.36.68-27-.4-40.29,2.06.37,3.33.66,3.33.66a22.3,22.3,0,0,0,.64-5.93c.44-22.28-27.39-58.2-38.74-71.9a32.42,32.42,0,0,0-13.07-11.34l-21.77-10.41S385.47,422,381.47,414.2c0-.13-.07-.27-.1-.41.45-.2.9-.41,1.34-.64a24.18,24.18,0,0,0,8.51-6.76c4.64-5.82,6.85-13.11,9-20.21,2.49-8.34,5-16.87,4.67-25.57s-4-17.74-11.51-22.36c-6.39-3.94-15.29-4.69-19.25-11-1.07-1.7-1.72-3.72-3.15-5.1a1.2,1.2,0,0,0-1-1.23l-11.1-2.14a1.21,1.21,0,0,0-1.41.94l0,.15a67,67,0,0,0-28.17,7.07,65.06,65.06,0,0,0-8.92,5.2c-4,2.82-8,6.54-8.56,11.38-.29,2.41.3,4.88-.2,7.24-1.32,6.32-9.89,10.43-8.64,16.76.84,4.3,5.77,6.15,10.38,6.16a34,34,0,0,0-1.29,9.25,34.45,34.45,0,0,0,27.71,33.61,98.12,98.12,0,0,1,8.79,14.78c-5.64,5.29-17.45,17.57-10.21,21.7l-15,36.74,1.46,37.89-6.35,5.61,1.39,1.72c-7.11,8.18-23.59,26.07-35.63,30.83a37,37,0,0,0-5,2.44,20.54,20.54,0,0,1-7.22,2.79,19.53,19.53,0,0,0-3.31.63l-2.87-5.89a4.32,4.32,0,0,0-5.74-2l-1.76.84h0l-4.19,2-1.74.83h0l-1.33.63a4.23,4.23,0,0,0-2,5.67l3.48,7.13c-4.95,4.31-7.37,9.46-.63,14.24a14.85,14.85,0,0,0,9,2.8l2.12,4.33a4.31,4.31,0,0,0,5.73,2l3.07-1.46,6-2.83a4.21,4.21,0,0,0,2-5.66l-1.74-3.57a70.44,70.44,0,0,0,10.64-10.08s8.93-5.53,14.19-6.76c3.49-.82,15.74-8.75,23.28-13.77l2.15,55.82a12.49,12.49,0,0,1-1.66,2l1.69-1.18,0,.41c-.25.28-.49.54-.73.77l.73-.52,0,.67a7.46,7.46,0,0,1-.76.81l.77-.54.22,5.8,3.69-6,.23,6,.86-1.41c-10.34,17.35-23.81,42.89-31,68.6,0,0-11.25,19.33-9.79,39.15L271.91,828.6l.4.15c-6.71,4.77-20.81,13.52-34.66,13.87,0,0-33.29-1-24,6.28s92,17.89,92,17.89l3.18-24.44.74.27s0-.14-.05-.38l1,.38s-2-12.09,5.38-18.85,24.48-75.41,23-86c0,0,13.14-32.43,29.59-58.29l19.36,49.11,21.54,36.74s28.65,62.9,27.73,76.92c-6,7.26-16.78,18.63-24.79,18.3,0,0-32.8,6.29-10.28,12.09s88.6-16,88.6-16ZM340.73,610.5l.2-.11c-1,1.55-2.11,3.28-3.29,5.17Z",
    transform: "translate(-28.64 -16.61)",
    fill: "url(#e499654a-3440-43b2-9cd0-3bdc531f1cd6-348)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M326.52,617.91c-.81.57-1.25.9-1.25.9A5.22,5.22,0,0,0,326.52,617.91Z",
    transform: "translate(-28.64 -16.61)",
    fill: "url(#57b4d689-d23d-4167-9afb-3be6c96fe0f2-349)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M327.5,618.87l-1.25.91A5.28,5.28,0,0,0,327.5,618.87Z",
    transform: "translate(-28.64 -16.61)",
    fill: "url(#eac37dd2-c948-4d6f-8054-18dfe5a953f0-350)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M327.5,617.91c-.81.57-1.25.9-1.25.9A5.22,5.22,0,0,0,327.5,617.91Z",
    transform: "translate(-28.64 -16.61)",
    fill: "url(#9e04d387-eaa7-45ec-87d4-96689ba1bc0d-351)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M439.51,836.81s-17.18,24.34-28.63,23.86c0,0-32,6.2-10,11.93s86.39-15.75,86.39-15.75l-7.66-25Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#333"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M362.67,667.86,387,730.38l21,36.27s28.88,64.19,27,76.6l46-7.4s-35.79-98.31-45.81-111.67c0,0-10.5-6.21-10-16.71L412.31,645s12.53-12.09,5.53-27.24a25.42,25.42,0,0,0-1.24-2.35c-9.54-16.22-45.81-7.16-45.81-7.16Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#535461"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M362.67,667.86,387,730.38l21,36.27s28.88,64.19,27,76.6l46-7.4s-35.79-98.31-45.81-111.67c0,0-10.5-6.21-10-16.71L412.31,645s12.53-12.09,5.53-27.24a25.42,25.42,0,0,0-1.24-2.35c-9.54-16.22-45.81-7.16-45.81-7.16Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.03
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.22,724.18s-10.5-6.21-10-16.71L412.31,645s12.53-12.09,5.53-27.24a25.42,25.42,0,0,0-1.24-2.35c-4.63-7.87-15.54-9.79-25.56-9.68,9.61.09,19.72,2.19,24.13,9.68a23.08,23.08,0,0,1,1.23,2.35c7,15.15-5.52,27.24-5.52,27.24l12.88,62.52c-.47,10.5,10,16.71,10,16.71,10,13.36,45.81,111.67,45.81,111.67L435,843c0,.07,0,.16,0,.23l46-7.4S445.24,737.54,435.22,724.18Z",
    transform: "translate(-28.64 -16.61)"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M278.2,826.31s-19.09,16.22-37.7,16.7c0,0-32.45-1-23.39,6.21s89.73,17.65,89.73,17.65L310.43,839Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#333"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.36,604.39s-31.5,44.38-43.91,89.24c0,0-11,19.09-9.54,38.66l-20.05,96.88L311.61,843s-1.91-11.93,5.25-18.61,23.86-74.45,22.43-84.95c0,0,22.91-57.27,45.82-79.7s34.3-27.61,37.67-47C422.78,612.77,368.88,586.73,348.36,604.39Z",
    transform: "translate(-28.64 -16.61)"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M347.4,604.39s-31.5,44.38-43.9,89.24c0,0-11,19.09-9.55,38.66l-20,96.88L310.65,843s-1.9-11.93,5.25-18.61,23.87-74.45,22.43-84.95c0,0,22.91-57.27,45.82-79.7s34.31-27.61,37.68-47C421.83,612.77,367.92,586.73,347.4,604.39Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#535461"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.75,597.78c23.66.28,53.12,14.52,53.12,14.52-3.37,19.36-14.77,24.54-37.67,47S337.38,739,337.38,739c1.43,10.5-15.27,78.27-22.43,84.95-6.23,5.82-5.59,15.61-5.32,18.05l1.5.56s-1.91-11.93,5.25-18.61,23.86-74.45,22.43-84.95c0,0,22.91-57.27,45.82-79.7s34.31-27.61,37.67-47C422.3,612.3,391.63,597.48,367.75,597.78Z",
    transform: "translate(-28.64 -16.61)"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M324,535.18s-22.78,28.37-38.16,34.53a37,37,0,0,0-4.9,2.4,19.88,19.88,0,0,1-7,2.76,16.94,16.94,0,0,0-5.33,1.4c-8,3.68-26.43,13.64-14.26,22.39,15.27,11,35.79-14.32,35.79-14.32s8.71-5.46,13.84-6.68S332.61,560,332.61,560Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#ecb4b6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "299.67 512.85 290.6 520.96 303.96 537.66 299.67 512.85",
    fill: "#479e35"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "299.67 512.85 290.6 520.96 303.96 537.66 299.67 512.85"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M351.29,434.48s-21.72,18.62-12.62,23.87L324,494.62l5.05,132.67,20.71-34.36-14.15-74.45s-4-44.38,7.58-54.88l11.11-22Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.16,427.83s-21.72,18.62-12.63,23.87L326.88,488l5.05,132.67,20.71-34.36L338.5,511.83s-4-44.38,7.57-54.88l11.12-22Z",
    transform: "translate(-28.64 -16.61)"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M334.52,414.92s17.66,21.47,17.18,33.88,33.41-21.47,33.41-21.47-12.89-15.75-9.55-32.46S334.52,414.92,334.52,414.92Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#ecb4b6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M435.22,522.78,440,561v37.7s-6.68,48.68,14.32,39.61S460,595.8,460,595.8s0-18.62,2.87-28.16-1.43-51.55-1.43-51.55Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#ecb4b6"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M369.83,432.58S357,445,350.27,440.69l-9.16,22.77a104.76,104.76,0,0,0-7.45,43.89l3.24,86.06,14.32-1.91L356,509.89l7.16-49.63Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#f2f2f2"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.57,419.45s-16.94,11.69-21.71,21.72c0,0-.48,11-4.3,15.75s-7.63,28.63-8.59,57.27S340.72,581,340.72,581s-7.16,37.23-14.79,41c0,0,35.31-26.72,52.49-17.65s36.75,31,42.48,27.68c0,0-1.38-41.83,4.88-64.14.12-.42.24-.84.37-1.25,6.68-21.95,2.39-52,10-64.9,0,0,0-23.33-4.4-40.75a31.49,31.49,0,0,0-16.85-20.56L393.7,430.19S382.48,428.52,380.57,419.45Z",
    transform: "translate(-28.64 -16.61)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.57,419.45s-16,12.65-20.76,22.67c0,0-.48,11-4.29,15.75s-7.64,28.64-8.59,57.27S341.68,582,341.68,582s-7.16,37.22-14.8,41c0,0,35.32-26.73,52.5-17.66s36.75,31,42.47,27.68c0,0-1.37-41.82,4.89-64.13.12-.43.24-.84.36-1.25,6.69-22,2.39-52,10-64.91,0,0,0-23.33-4.41-40.74a31.47,31.47,0,0,0-16.84-20.57l-21.23-10.28S382.48,428.52,380.57,419.45Z",
    transform: "translate(-28.64 -16.61)"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M380.33,419.21s-15.75,11.93-20.52,22c0,0-.48,11-4.29,15.75s-7.64,28.63-8.59,57.27S341.68,581,341.68,581s-7.16,37.23-14.8,41c0,0,35.32-26.72,52.5-17.65s36.75,31,42.47,27.68c0,0-1.37-41.83,4.89-64.14l.36-1.25c6.69-21.95,2.39-52,10-64.9,0,0,0-23.33-4.41-40.75a31.45,31.45,0,0,0-16.84-20.56l-21.23-10.28S383.91,427.56,380.33,419.21Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424,447.13s48.44,55.12,41.76,81.37c0,0-24.82-5.72-31.5,1.91,0,0-5.25-17.66-21-27.68S383,428.52,424,447.13Z",
    transform: "translate(-28.64 -16.61)"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M424,446.18s48.44,55.12,41.76,81.37c0,0-24.82-5.73-31.5,1.91,0,0-5.25-17.66-21-27.68S383,427.56,424,446.18Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.75,405.61c-.75-3.85-.12-4.14.72-8.35,3.34-16.7-41,20-41,20s2.47,3,5.53,7.42a33.85,33.85,0,0,0,6.87.7C361,425.42,370.77,415.18,376.75,405.61Z",
    transform: "translate(-28.64 -16.61)"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.28,
    cy: 372.53,
    r: 33.88,
    fill: "#ecb4b6"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.48,379.87c-5,.67-11.35-1-12.31-5.94-1.21-6.24,7.14-10.31,8.43-16.54.49-2.34-.09-4.78.19-7.15.56-4.78,4.42-8.46,8.35-11.23a64.24,64.24,0,0,1,42.74-11.39,9.54,9.54,0,0,1,5.29,1.67c1.65,1.36,2.28,3.55,3.4,5.36,3.87,6.25,12.54,7,18.77,10.88,7.29,4.55,10.89,13.48,11.22,22.07s-2.12,17-4.55,25.25c-2.06,7-4.22,14.2-8.74,19.94s-12,9.76-19.13,8c3.26-2.35.9-7.79-2.63-9.7s-7.9-2.24-10.91-4.87-3.92-6.95-4.91-10.87c-1.24-5-3-10-6.64-13.59C338,374.7,325.18,378.7,316.48,379.87Z",
    transform: "translate(-28.64 -16.61)"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M317.44,379.39c-5,.68-11.35-1-12.32-5.93-1.21-6.25,7.14-10.31,8.44-16.55.48-2.34-.1-4.77.18-7.15.56-4.78,4.43-8.45,8.36-11.23a64.26,64.26,0,0,1,42.73-11.39,9.55,9.55,0,0,1,5.29,1.68c1.65,1.35,2.29,3.54,3.41,5.35,3.86,6.25,12.54,7,18.77,10.88,7.28,4.55,10.89,13.49,11.21,22.07s-2.12,17-4.54,25.25c-2.07,7-4.22,14.21-8.75,19.95s-12,9.75-19.12,8c3.25-2.34.89-7.79-2.63-9.7s-7.9-2.23-10.92-4.87-3.92-6.95-4.9-10.87c-1.24-4.95-3-10-6.64-13.58C338.92,374.22,326.13,378.22,317.44,379.39Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#464353"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M367.38,345l3.07-15.72a1.17,1.17,0,0,0-.93-1.37l-10.82-2.11a1.16,1.16,0,0,0-1.37.92l-3.07,15.71-10.49,38.8L363,385Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.19,358.16a10.77,10.77,0,0,0,1.5-3.51c.48-2.34-.1-4.78.18-7.15a10.76,10.76,0,0,1,.61-2.47,11.43,11.43,0,0,0-1.74,4.73c-.28,2.38.3,4.81-.19,7.15A7.48,7.48,0,0,1,313.19,358.16Z",
    transform: "translate(-28.64 -16.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.35,410.05c-4.45,5.66-11.8,9.62-18.8,8.09a3.64,3.64,0,0,1-1.45,2.2c7.1,1.73,14.6-2.28,19.12-8a34.9,34.9,0,0,0,4.26-7.11A31.74,31.74,0,0,1,391.35,410.05Z",
    transform: "translate(-28.64 -16.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.6,417.75c2.67-2.48.37-7.54-3-9.37-3.53-1.91-7.9-2.24-10.92-4.87s-3.92-6.95-4.9-10.88c-1.24-4.95-3-10-6.64-13.58-7.09-7.09-19.88-3.09-28.57-1.92-5,.67-11.35-1-12.31-5.94a6.51,6.51,0,0,1,.28-3.49,7.74,7.74,0,0,0-1.42,5.76c1,4.94,7.33,6.61,12.32,5.93,8.69-1.17,21.48-5.17,28.57,1.93,3.6,3.61,5.4,8.63,6.64,13.58,1,3.92,1.85,8.21,4.9,10.87s7.39,3,10.92,4.87C371,412,372.91,415.2,372.6,417.75Z",
    transform: "translate(-28.64 -16.61)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 322.82,
    cy: 373.25,
    r: 16.7
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.82,
    cy: 373.73,
    r: 16.7,
    fill: "#479e35"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.82,
    cy: 373.73,
    r: 10.94,
    fill: "#333"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.82,
    cy: 373.73,
    r: 3.34,
    fill: "#479e35"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 354.37,
    y: 342.33,
    width: 13.36,
    height: 0.48,
    transform: "translate(43.72 -79.47) rotate(11.05)",
    opacity: 0.05
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 257.54,
    y: 568.29,
    width: 16.23,
    height: 39.61,
    rx: 6.34,
    ry: 6.34,
    transform: "translate(-257.72 157.15) rotate(-25.74)",
    fill: "#cbdae3"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 257.54,
    y: 568.29,
    width: 16.23,
    height: 39.61,
    rx: 1.45,
    ry: 1.45,
    transform: "translate(-257.72 157.15) rotate(-25.74)",
    fill: "#535461"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 258.8,
    y: 567.57,
    width: 16.7,
    height: 39.61,
    rx: 1.64,
    ry: 1.64,
    transform: "translate(-257.26 157.73) rotate(-25.74)",
    fill: "#479e35"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 260.01,
    y: 570.62,
    width: 12.62,
    height: 30.07,
    transform: "translate(-256.59 157.2) rotate(-25.74)",
    fill: "#f2f2f2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 274.52,
    cy: 602.1,
    rx: 1.43,
    ry: 1.91,
    transform: "translate(-262.92 162.4) rotate(-25.74)",
    fill: "#f2f2f2"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.4,573.89a54.82,54.82,0,0,1,19.6,3.86c10,4.06,20.59,0,20.59,0S372.43,569,362.4,573.89Z",
    transform: "translate(-28.64 -16.61)"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M706.63,754.23s6.22,8.13-2.87,20.41-16.58,22.64-13.55,30.29c0,0,13.71-22.8,24.87-23.12S718.91,767.94,706.63,754.23Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M706.63,754.23a10,10,0,0,1,1.27,2.55c10.89,12.79,16.7,24.73,6.23,25-9.75.28-21.45,17.72-24.25,22.12a9,9,0,0,0,.33,1s13.71-22.8,24.87-23.12S718.91,767.94,706.63,754.23Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M718.19,764.59c0,2.87-.32,5.19-.71,5.19s-.72-2.32-.72-5.19.4-1.51.8-1.51S718.19,761.73,718.19,764.59Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#ffd037"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M722.16,768c-2.51,1.37-4.7,2.2-4.89,1.85s1.69-1.74,4.2-3.11,1.53-.37,1.72,0S724.67,766.64,722.16,768Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#ffd037"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M673.79,754.23s-6.22,8.13,2.87,20.41,16.58,22.64,13.55,30.29c0,0-13.71-22.8-24.87-23.12S661.51,767.94,673.79,754.23Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M673.79,754.23a10,10,0,0,0-1.27,2.55c-10.89,12.79-16.69,24.73-6.22,25,9.75.28,21.44,17.72,24.24,22.12a9,9,0,0,1-.33,1s-13.71-22.8-24.87-23.12S661.51,767.94,673.79,754.23Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.1
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M662.23,764.59c0,2.87.32,5.19.72,5.19s.72-2.32.72-5.19-.41-1.51-.8-1.51S662.23,761.73,662.23,764.59Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#ffd037"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M658.26,768c2.52,1.37,4.71,2.2,4.9,1.85s-1.7-1.74-4.21-3.11-1.52-.37-1.71,0S655.75,766.64,658.26,768Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#ffd037"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M664.21,803.87s17.39-.54,22.63-4.27,26.74-8.18,28-2.2,26.12,29.76,6.5,29.92-45.61-3.06-50.84-6.25S664.21,803.87,664.21,803.87Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#a8a8a8"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M721.73,825.23c-19.63.16-45.61-3.05-50.84-6.24-4-2.42-5.57-11.13-6.1-15.14l-.58,0s1.1,14,6.33,17.2,31.21,6.41,50.84,6.25c5.66-.05,7.62-2.06,7.51-5.05C728.11,824.07,725.94,825.2,721.73,825.23Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.2
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M630.69,816.63a9.26,9.26,0,0,0,3-4.58c.39-1.81-.39-4-2.12-4.65-2-.75-4,.6-5.6,2s-3.39,2.92-5.45,2.63a8.28,8.28,0,0,0,2.56-7.76,3.26,3.26,0,0,0-.71-1.58c-1.08-1.15-3-.65-4.33.26-4.11,2.89-5.26,8.47-5.28,13.5-.42-1.81-.07-3.7-.08-5.56s-.52-3.92-2.09-4.92a6.2,6.2,0,0,0-3.18-.75c-1.85-.07-3.91.11-5.17,1.47-1.57,1.68-1.16,4.5.2,6.34s3.44,3,5.35,4.29a11.7,11.7,0,0,1,3.82,3.65,3,3,0,0,1,.29.65h11.59A32.2,32.2,0,0,0,630.69,816.63Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M552.13,810.14s-11.12-37.73,2.08-65.5A59.59,59.59,0,0,0,559,707.25a101.21,101.21,0,0,0-5.29-17.55",
    transform: "translate(-28.64 -16.61)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M562,672.15c0,4.62-8.38,18-8.38,18s-8.37-13.41-8.37-18a8.38,8.38,0,0,1,16.75,0Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M575.79,697.76c-2.52,3.89-16.83,10.59-16.83,10.59s.26-15.81,2.77-19.69a8.37,8.37,0,0,1,14.06,9.1Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M575.18,741.53c-4.13,2.09-19.87.65-19.87.65s8.2-13.52,12.33-15.6a8.37,8.37,0,1,1,7.54,14.95Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M567.27,774.55c-3.72,2.75-19.48,4-19.48,4s5.8-14.71,9.52-17.46a8.38,8.38,0,0,1,10,13.47Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M541.38,709.25c3.31,3.22,18.77,6.56,18.77,6.56s-3.79-15.35-7.1-18.57a8.37,8.37,0,1,0-11.67,12Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M532.61,748c4.13,2.09,19.87.65,19.87.65s-8.2-13.52-12.33-15.6a8.37,8.37,0,1,0-7.54,15Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M529.25,786.78c3.72,2.75,19.48,4,19.48,4s-5.8-14.71-9.52-17.46a8.37,8.37,0,1,0-10,13.46Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M562,672.15c0,4.62-8.38,18-8.38,18s-8.37-13.41-8.37-18a8.38,8.38,0,0,1,16.75,0Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M575.79,697.76c-2.52,3.89-16.83,10.59-16.83,10.59s.26-15.81,2.77-19.69a8.37,8.37,0,0,1,14.06,9.1Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M575.18,741.53c-4.13,2.09-19.87.65-19.87.65s8.2-13.52,12.33-15.6a8.37,8.37,0,1,1,7.54,14.95Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M567.27,774.55c-3.72,2.75-19.48,4-19.48,4s5.8-14.71,9.52-17.46a8.38,8.38,0,0,1,10,13.47Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M541.38,709.25c3.31,3.22,18.77,6.56,18.77,6.56s-3.79-15.35-7.1-18.57a8.37,8.37,0,1,0-11.67,12Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M532.61,748c4.13,2.09,19.87.65,19.87.65s-8.2-13.52-12.33-15.6a8.37,8.37,0,1,0-7.54,15Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M529.25,786.78c3.72,2.75,19.48,4,19.48,4s-5.8-14.71-9.52-17.46a8.37,8.37,0,1,0-10,13.46Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#479e35"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M525.86,807.76s13.53-2.69,17.14-6.27,19.85-9.85,21.65-5.38,24.36,19.71,9,22.4-36.08,3.58-40.59,1.79S525.86,807.76,525.86,807.76Z",
    transform: "translate(-28.64 -16.61)",
    fill: "#a8a8a8"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M573.68,816.84c-15.34,2.69-36.09,3.58-40.6,1.79-3.44-1.36-5.82-7.92-6.77-11l-.45.1s2.71,10.75,7.22,12.54,25.26.89,40.6-1.79c4.42-.78,5.69-2.6,5.21-4.91C578.51,815.11,577,816.26,573.68,816.84Z",
    transform: "translate(-28.64 -16.61)",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity2);
export default __webpack_public_path__ + "static/media/city2.ae109c9c7ac0c07143495856480a1298.svg";
export { ForwardRef as ReactComponent };